import {Component} from '@angular/core';

@Component({
    selector: 'ui-loader',
    styleUrls: ['loader.component.scss'],
    template: ''
})
export class UILoaderComponent {
}